import { connectHook } from 'app/common/components/connect-hook';
import { Link } from './link.js';
import { useLink } from './link-hook.js';

export default connectHook(Link, useLink);
